import React from "react";
import { options } from "./utils";
import { useSubscribeState } from "src/store/features/subscribe.slice";

export default function useFilterState() {
  const { brokerage, fund, marketing } = useSubscribeState();

  const filteredOptions = options.map((el) => {
    let subscribed;

    // Check if user has subscribed for x group
    if (el.group === "brokerage") {
      subscribed = brokerage;
    } else if (el.group === "fund") {
      subscribed = fund;
    } else {
      subscribed = marketing;
    }

    return {
      ...el,
      subscribed,
    };
  });

  return [filteredOptions];
}
